import { useS } from '../../store/game';
import { Panel } from '../../components/ui';
import { IND, indGood, fmtInd, fmtDelta } from '../../engine/indicators';
import { ltText } from '../../content/issues';
import { MONTHS } from '../../content/consts';
import { dateLabel } from '../../engine/util';

function Spark({ arr, x }: { arr: number[]; x: any }) {
  if (!arr || arr.length < 2) return <div className="spark" />;
  const w = 120, h = 30, mn = Math.min(...arr), mx = Math.max(...arr), r = (mx - mn) || 1;
  const pts = arr.map((v, i) => [(i / (arr.length - 1) * w), (h - 3 - (v - mn) / r * (h - 6))]);
  const g = indGood(x, arr[0], arr[arr.length - 1]), P = pts.map((p) => p[0].toFixed(1) + ',' + p[1].toFixed(1)).join(' '), L = pts[pts.length - 1];
  const c = g > 0 ? 'g' : g < 0 ? 'b' : '';
  return <svg className="spark" viewBox={`0 0 ${w} ${h}`} preserveAspectRatio="none" aria-hidden="true"><polygon points={`0,${h} ${P} ${w},${h}`} className="sa" /><polyline points={P} className={'sl ' + c} /><circle cx={L[0].toFixed(1)} cy={L[1].toFixed(1)} r="2.6" className={'sd ' + c} /></svg>;
}

export function Zahlen() {
  const S = useS();
  const lte = (S.lte || []).slice().sort((a: any, b: any) => a.from - b.from);
  return <>
    <Panel title="Land in Zahlen" aside={`Veränderung seit ${S.legYear}`}>
      <p className="sub">Die Kennzahlen reagieren träge auf Gesetze, Haushalt und Probleme. Was ihr heute beschließt, zeigt sich oft erst Jahre später.</p>
      <div className="inds">{IND.map((x: any) => { const v = S.ind[x.id], v0 = S.ind0[x.id], g = indGood(x, v0, v); return (
        <div className="ind" key={x.id}><span className="label">{x.n}</span><div className="iv"><b className="num">{fmtInd(x, v)}</b><span className={'num dl ' + (g > 0 ? 'up' : g < 0 ? 'down' : '')}>{fmtDelta(x, v - v0)}</span></div><Spark arr={S.hist[x.id]} x={x} /></div>); })}</div>
    </Panel>
    <Panel title="Langzeitwirkungen" aside={`${lte.length} geplant oder laufend`}>
      {lte.length ? <div className="ltl">{lte.map((x: any, i: number) => { const run = S.m >= x.from, next = !run && x.from >= S.m0 + MONTHS; return (
        <div className={'lt' + (run ? ' run' : '')} key={i}><span className="m">{run ? 'läuft' : 'ab ' + dateLabel(x.from)}</span><div className="mi"><b>{x.t}</b><span className="sub">{ltText(x.e)}{next ? ' · fällt in die nächste Legislatur' : ''}</span></div></div>); })}</div>
        : <span className="sub">Noch keine. Gesetze zu Bildung, Infrastruktur, Rente, Klima oder Ärzteausbildung wirken oft erst nach Jahren nach, manche auch negativ.</span>}
    </Panel>
  </>;
}
